import React from 'react';
import { Divider, DividerProps, LineAboveDivider, NoLineDivider, TwoLineDivider } from '@moda/om';
import { useFeatureFlag } from '@moda/portal-stanchions';

export const DIVIDER_LAYOUT_TYPES = {
  ONE_LINE: 1,
  TWO_LINE: 2,
  NO_LINE: 3,
  LINE_ABOVE: 4
};

export interface DividerModuleProps {
  layoutType: number | null;
  text: string | null;
  verticalPadding?: string | null;
  bgColor?: string | null;
  modelId?: string | null;
  moduleType?: string | null;
}

export const DividerModule: React.FC<DividerModuleProps> = ({
  layoutType,
  text,
  verticalPadding,
  bgColor,
  modelId,
  moduleType
}) => {
  const useNewDividerLine = useFeatureFlag('new-divider-line', [
    { default: false },
    { if: true, then: true }
  ]);

  let DividerComponent: React.FC<DividerProps>;

  switch (layoutType) {
    case DIVIDER_LAYOUT_TYPES.ONE_LINE:
      DividerComponent = Divider;
      break;
    case DIVIDER_LAYOUT_TYPES.TWO_LINE:
      DividerComponent = useNewDividerLine ? LineAboveDivider : TwoLineDivider;
      break;
    case DIVIDER_LAYOUT_TYPES.NO_LINE:
      DividerComponent = NoLineDivider;
      break;
    case DIVIDER_LAYOUT_TYPES.LINE_ABOVE:
      DividerComponent = useNewDividerLine ? LineAboveDivider : Divider;
      break;
    default:
      DividerComponent = useNewDividerLine ? LineAboveDivider : Divider;
  }

  return (
    <div className="DividerModule" data-model-id={modelId} data-module-type={moduleType}>
      <DividerComponent
        text={text || ''}
        style={{
          padding: `${verticalPadding} 0`,
          ...(bgColor ? { backgroundColor: bgColor } : {})
        }}
      />
    </div>
  );
};
